import React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import './DatePickerComponent.css';

const DatePickerComponent = ({ selectedDate, onDateChange, timeSlots, selectedTimeSlot, onTimeSlotSelect }) => {
    const isDateSelectable = date => {
        return moment(date).isSameOrAfter(moment().add(1, 'days'), 'day');
    };

    return (
        <div style={{ display: 'flex' }}>
            <div style={{ marginRight: '20px' }}>
                <DatePicker
                    selected={selectedDate}
                    onChange={onDateChange}
                    filterDate={isDateSelectable}
                    inline
                />
            </div>
            <div>
                <h3>Select a Malaysia Time Slot</h3>
                {timeSlots.length === 0 && <p>Please select a date.</p>}
                <div className="time-slots">
                    {timeSlots.map((slot, index) => (
                        <button
                            key={index}
                            onClick={() => onTimeSlotSelect(slot)}
                            className={`time-slot-button ${selectedTimeSlot === slot ? 'selected' : ''}`}
                        >
                            {slot}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DatePickerComponent;